export default {
  linkShareTemplates: {
    edit: 'Edit',
    resetToDefault: 'Reset to default',
    save: 'Save',
    required: 'Required',
    editDialogTitle: (templateType: string): string => `Edit ${templateType} Template`,
    emailSubjectLabel: 'Email Subject',
    emailBodyLabel: 'Email Body',
    smsBodyLabel: 'SMS Body',
  },
  videoCallTemplates: {
    heading: 'Customize Video Call invitation',
    subtitle: 'Edit templates for email and sms video calls invitations',
    emailSectionTitle: 'Email Invitation',
    smsSectionTitle: 'SMS Invitation',
  },
};
